<div class="ac-file-container">
    <div *ngIf="!fileIsReady" class="ac-file-in-progress">
        <ac-progress [center]="false"></ac-progress>
    </div>

    <div *ngIf="fileIsReady" class="file-box-container">
        <div class="flexRowParent file-actions-container" *ngIf="showFileSelection">
            <ac-input-container [formFieldName]="'fileObject.' + this.filePropertyName" *ngIf="showList"
                                [label]="label" class="flexItemBiggest" [sideMargin]="false" [readOnly]="readOnly">
                <ac-single-select  [acModel]="fileObject[this.filePropertyName]"
                                   (acModelChange)="fileObject[this.filePropertyName] = $event;fileIdChanged.emit($event);readImage()"
                                   [bindLabel]="'name'"
                                   [bindValue]="'id'"
                                   [items]="fileObject.files"
                                   [class.allowUpload]="allowUpload"
                                   [ngDisabled]="ngDisabled">
                </ac-single-select>
            </ac-input-container>

            <ac-file-picker (acChanged)="onFileChange($event);fileWasPicked.emit()" *ngIf="allowUpload"
                            [fileTypeAllowed]="fileTypes"
                            [ngDisabledColor]="statusColorsList.disabledDark"
                            [ngDisabled]="ngDisabled"
                            [onlyIcon]="true"
                            class="upload-icon flexItem">
            </ac-file-picker>
        </div>

        <div *ngIf="showImage" class="image-container">
            <img *ngIf="filePath" [src]="filePath"/>
            <div *ngIf="!filePath" class="empty-file"></div>
        </div>

        <div *ngIf="showText" class="text-container">
            <markdown *ngIf="fileContent" class="markdown" [data]="fileContent"></markdown>
            <!--                <div *ngIf="fileContent" class="flexItemBiggest">{{fileContent}}</div>-->
            <div *ngIf="!fileContent" class="empty-file"></div>
        </div>
    </div>
</div>
